import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import { seedPeecIndexedDB } from './db/seedDB';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

seedPeecIndexedDB()
  .catch((error) => {
    console.error('Failed to seed IndexedDB:', error);
  })
  .finally(() => {
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );
  });
